// src/api_scripts/createSkillProfile.js
import { createApiClient } from "../apiClient";

const createSkillProfile = async (skillProfileData, orgId, accessToken, setProgress) => {
  const { name } = skillProfileData.name;

  setProgress((prev) => [
    ...prev,
    { type: 'info', message: `Attempting to create Skill Profile: "${name}"...`, timestamp: new Date().toLocaleTimeString() }
  ]);


  // API endpoint for creating a new Skill Profile
  const relativeUri = `organization/${orgId}/skill-profile`;

  try {
    const apiClient = createApiClient(accessToken);
    const response = await apiClient.post(relativeUri, skillProfileData);

    const newSkillProfile = response.data; // The API returns the created resource directly

    console.log("Create Skill Profile API Response Data:", newSkillProfile);

    setProgress((prev) => [
      ...prev,
      { type: 'success', message: `Successfully created Skill Profile "${name}" (ID: ${newSkillProfile.id}).`, timestamp: new Date().toLocaleTimeString() }
    ]);

    return newSkillProfile.id; // Return the created Skill Profile object (includes its ID)

  } catch (error) {
    console.error(`Error creating Skill Profile "${name}":`, error);

    let errorMessage = `Error creating Skill Profile "${name}": ${error.message || String(error)}`;

    if (error.response && error.response.data) {
      if (error.response.data.error && error.response.data.error.reason) {
        errorMessage += ` (Reason: ${error.response.data.error.reason})`;
      } else if (error.response.data.message) {
        errorMessage += ` (Detail: ${error.response.data.message})`;
      } else if (typeof error.response.data === 'string') {
        errorMessage += ` (Response: ${error.response.data})`;
      }
    }

    setProgress((prev) => [
      ...prev,
      { type: 'error', message: errorMessage, timestamp: new Date().toLocaleTimeString() }
    ]);
    throw error;
  }
};

export default createSkillProfile;
